export { default as createTableReducer } from './createTableReducer';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/common/table/reducers/index.js